import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { FallaDesembarqueService } from '../../../services/FallaDesembarqueService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'falla_desembarque',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. FD-01',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'falla_desmb_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Descripción de la falla',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const FallaDesembarqueForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await FallaDesembarqueService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await FallaDesembarqueService.guardar(values);
  };

  return (
    <CatalogForm
      title="Falla de Desembarque"
      subtitle="Registro de incidencias y anomalías en desembarque"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/FallasDesembarques"
    />
  );
};

export default FallaDesembarqueForm;
